var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _vm.prevRouteName
        ? _c(
            "nav",
            [
              _c(
                "router-link",
                { attrs: { to: { name: _vm.prevRouteName } } },
                [
                  _c(
                    "el-button",
                    { attrs: { type: "primary", icon: "el-icon-arrow-left" } },
                    [
                      _vm._v(
                        "Back to " + _vm._s(_vm.routeLabel(_vm.prevRouteName))
                      )
                    ]
                  )
                ],
                1
              )
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _c("el-container", [
        _c("main", { attrs: { id: "profile" } }, [
          _c("h2", [_vm._v("Update Your Details")]),
          _vm._v(" "),
          _c(
            "div",
            {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value:
                    _vm.updateCustomerStatus == "pending" ||
                    _vm.getCustomerStatus == "pending",
                  expression:
                    "updateCustomerStatus == 'pending' || getCustomerStatus == 'pending'"
                }
              ]
            },
            [
              _vm.customer && _vm.customer.id
                ? _c(
                    "el-form",
                    {
                      attrs: {
                        novalidate: "true",
                        "label-width": "10em",
                        "label-position": _vm.formLabelPosition,
                        size: _vm.formSize
                      }
                    },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: "Title", error: _vm.errors.title } },
                        [
                          _c(
                            "el-select",
                            {
                              attrs: { placeholder: "Title", filterable: "" },
                              model: {
                                value: _vm.customer.title,
                                callback: function($$v) {
                                  _vm.$set(_vm.customer, "title", $$v)
                                },
                                expression: "customer.title"
                              }
                            },
                            _vm._l(_vm.titles, function(title) {
                              return _c("el-option", {
                                key: title,
                                attrs: { label: title, value: title }
                              })
                            }),
                            1
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: "First Name",
                            error: _vm.errors.first_name
                          }
                        },
                        [
                          _c("el-input", {
                            attrs: { placeholder: "First Name" },
                            model: {
                              value: _vm.customer.first_name,
                              callback: function($$v) {
                                _vm.$set(_vm.customer, "first_name", $$v)
                              },
                              expression: "customer.first_name"
                            }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: "Last Name",
                            error: _vm.errors.last_name
                          }
                        },
                        [
                          _c("el-input", {
                            attrs: { placeholder: "Last Name" },
                            model: {
                              value: _vm.customer.last_name,
                              callback: function($$v) {
                                _vm.$set(_vm.customer, "last_name", $$v)
                              },
                              expression: "customer.last_name"
                            }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: "Phone Number",
                            error: _vm.errors.phone_number
                          }
                        },
                        [
                          _c("el-input", {
                            attrs: { placeholder: "Phone Number" },
                            model: {
                              value: _vm.customer.phone_number,
                              callback: function($$v) {
                                _vm.$set(_vm.customer, "phone_number", $$v)
                              },
                              expression: "customer.phone_number"
                            }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _vm.accountFields.includes("zip_code")
                        ? _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: "Postcode",
                                error: _vm.errors.zip_code
                              }
                            },
                            [
                              _c("el-input", {
                                directives: [
                                  {
                                    name: "mask",
                                    rawName: "v-mask",
                                    value: _vm.postcodeMask,
                                    expression: "postcodeMask"
                                  }
                                ],
                                attrs: {
                                  placeholder: "Postcode",
                                  type: "text"
                                },
                                model: {
                                  value: _vm.customer.zip_code,
                                  callback: function($$v) {
                                    _vm.$set(_vm.customer, "zip_code", $$v)
                                  },
                                  expression: "customer.zip_code"
                                }
                              }),
                              _vm._v(" "),
                              _vm.hasGetAddress
                                ? _c(
                                    "div",
                                    { staticClass: "postcode-lookup" },
                                    [
                                      _c(
                                        "el-button",
                                        {
                                          attrs: {
                                            type: "primary",
                                            loading:
                                              _vm.getAddressStatus == "pending"
                                          },
                                          on: { click: _vm.postcodeLookup }
                                        },
                                        [_vm._v("Find Address")]
                                      ),
                                      _vm._v(" "),
                                      _vm.addresses.length
                                        ? _c(
                                            "el-select",
                                            {
                                              attrs: {
                                                placeholder: "Select an Address"
                                              },
                                              model: {
                                                value: _vm.selectedAddress,
                                                callback: function($$v) {
                                                  _vm.selectedAddress = $$v
                                                },
                                                expression: "selectedAddress"
                                              }
                                            },
                                            _vm._l(_vm.addresses, function(
                                              address,
                                              index
                                            ) {
                                              return _c("el-option", {
                                                key: index,
                                                attrs: {
                                                  label: _vm.formatAddress(
                                                    address
                                                  ),
                                                  value: index
                                                }
                                              })
                                            }),
                                            1
                                          )
                                        : _vm._e()
                                    ],
                                    1
                                  )
                                : _vm._e()
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.accountFields.includes("street_number")
                        ? _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: "Property Name/Number",
                                error: _vm.errors.street_number
                              }
                            },
                            [
                              _c("el-input", {
                                attrs: { placeholder: "Property Name/Number" },
                                model: {
                                  value: _vm.customer.street_number,
                                  callback: function($$v) {
                                    _vm.$set(_vm.customer, "street_number", $$v)
                                  },
                                  expression: "customer.street_number"
                                }
                              })
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.accountFields.includes("street")
                        ? _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: "Street",
                                error: _vm.errors.street
                              }
                            },
                            [
                              _c("el-input", {
                                attrs: { placeholder: "Street" },
                                model: {
                                  value: _vm.customer.street,
                                  callback: function($$v) {
                                    _vm.$set(_vm.customer, "street", $$v)
                                  },
                                  expression: "customer.street"
                                }
                              })
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.accountFields.includes("city")
                        ? _c(
                            "el-form-item",
                            {
                              attrs: { label: "City", error: _vm.errors.city }
                            },
                            [
                              _c("el-input", {
                                attrs: { placeholder: "City" },
                                model: {
                                  value: _vm.customer.city,
                                  callback: function($$v) {
                                    _vm.$set(_vm.customer, "city", $$v)
                                  },
                                  expression: "customer.city"
                                }
                              })
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.accountFields.includes("country")
                        ? _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: "Country",
                                error: _vm.errors.country
                              }
                            },
                            [
                              _c(
                                "el-select",
                                {
                                  attrs: {
                                    placeholder: "Country",
                                    filterable: ""
                                  },
                                  model: {
                                    value: _vm.customer.country,
                                    callback: function($$v) {
                                      _vm.$set(_vm.customer, "country", $$v)
                                    },
                                    expression: "customer.country"
                                  }
                                },
                                _vm._l(_vm.countries, function(country) {
                                  return _c("el-option", {
                                    key: country,
                                    attrs: { label: country, value: country }
                                  })
                                }),
                                1
                              )
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.user &&
                      _vm.user.provider == "remote" &&
                      !_vm.user.is_guest
                        ? _c(
                            "el-form-item",
                            [
                              _c("el-checkbox", {
                                attrs: {
                                  label: "I would like to change my password"
                                },
                                model: {
                                  value: _vm.changePassword,
                                  callback: function($$v) {
                                    _vm.changePassword = $$v
                                  },
                                  expression: "changePassword"
                                }
                              })
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.user &&
                      _vm.user.provider == "remote" &&
                      !_vm.user.is_guest &&
                      _vm.changePassword
                        ? _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: "New Password",
                                error: _vm.errors.password
                              }
                            },
                            [
                              _c("el-input", {
                                attrs: {
                                  placeholder: "Change your password",
                                  "show-password": ""
                                },
                                model: {
                                  value: _vm.customer.password,
                                  callback: function($$v) {
                                    _vm.$set(_vm.customer, "password", $$v)
                                  },
                                  expression: "customer.password"
                                }
                              })
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.user &&
                      _vm.user.provider == "remote" &&
                      !_vm.user.is_guest &&
                      _vm.changePassword
                        ? _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: "Confirm Password",
                                error: _vm.errors.password_confirmation
                              }
                            },
                            [
                              _c("el-input", {
                                attrs: {
                                  placeholder: "Confirm your new password",
                                  "show-password": ""
                                },
                                model: {
                                  value: _vm.customer.password_confirmation,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.customer,
                                      "password_confirmation",
                                      $$v
                                    )
                                  },
                                  expression: "customer.password_confirmation"
                                }
                              })
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.user && !_vm.user.is_guest
                        ? _c(
                            "el-form-item",
                            [
                              _c("el-checkbox", {
                                attrs: {
                                  label:
                                    _vm.allowEmailsLabel ||
                                    "I consent to being contacted by email",
                                  "true-label": "Yes",
                                  "false-label": "No"
                                },
                                model: {
                                  value: _vm.customer.allow_e_mails,
                                  callback: function($$v) {
                                    _vm.$set(_vm.customer, "allow_e_mails", $$v)
                                  },
                                  expression: "customer.allow_e_mails"
                                }
                              })
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _c(
                        "el-form-item",
                        [
                          _c(
                            "el-button",
                            {
                              staticClass: "proceed",
                              attrs: { type: "success" },
                              on: { click: _vm.submit }
                            },
                            [
                              _vm._v(_vm._s(_vm.nextLabel) + " "),
                              _c("i", { staticClass: "el-icon-arrow-right" })
                            ]
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                : _vm._e()
            ],
            1
          )
        ]),
        _vm._v(" "),
        _c(
          "aside",
          [
            _c("cart", { attrs: { activeMobileSections: [] } }),
            _vm._v(" "),
            _c(
              "el-button",
              {
                staticClass: "proceed",
                attrs: { type: "success" },
                on: { click: _vm.submit }
              },
              [
                _vm._v(_vm._s(_vm.nextLabel) + " "),
                _c("i", { staticClass: "el-icon-arrow-right" })
              ]
            )
          ],
          1
        )
      ])
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }